import Mn from 'backbone.marionette';

const template = require('./404.pug');

export default Mn.View.extend({
  template(data: {}) {
    return template(data);
  },
});
